import config from '../config.json';
import { getRandomString } from '../services/AuthService';
import testers from '../testers.json';
import { getEnvironment } from './EnvironmentVariable';

export const getBravoData = async () => {
  const environ = getEnvironment();
  let portalAuthApi = config.bravoAuthAPI;
  let portalKey = config.bravoKey;
  let portalApi = config.bravoDataAPI;
  let sentBravoAPI = config.sentBravoAPI;

  if (environ !== 'DEFAULT') {
    portalAuthApi = config.test_bravoAuthAPI;
    portalKey = config.test_bravoKey;
    portalApi = config.test_bravoDataAPI;
    sentBravoAPI = config.test_sentBravoAPI;
  }
  const userInfo = JSON.parse(sessionStorage.getItem('userinfo'));
  if (!userInfo || !userInfo.shortName) {
    return { error: 'No user information found.' };
  }
  let shortName = userInfo.shortName
    ? userInfo.shortName.toUpperCase()
    : userInfo.username.toUpperCase();

  const testUsers = testers.users;
  for (let x = 0; x < testUsers.length; x++) {
    const tester = testUsers[x];
    if (tester.shortName.toUpperCase() === shortName.toUpperCase()) {
      //User shortname matches to a tester
      if (environ === 'DEFAULT') {
        //This is the production environment
        if (tester.prodAllowed) {
          //This tester is allowed to mimic in production
          shortName = tester.mimicManager.toUpperCase();
        }
      } else {
        //This is not a production environment
        shortName = tester.mimicManager.toUpperCase();
      }
      break;
    }
  }
  // sessionStorage.removeItem('access_token');
  const message = getRandomString(25);
  const token = sessionStorage.getItem('access_token');

  let headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded');
  headers.append('Authorization', 'Bearer ' + token);
  headers.append('X-NW-Message-ID', message);
  headers.set('client_id', portalKey);

  const body = encodeKeyValuePair('grant_type', 'client_credentials');
  let data = null;
  try {
    const response = await fetch(portalAuthApi, {
      method: 'post',
      headers: headers,
      body: body,
    });
    if (response.ok) {
      try {
        data = await response.json();
        //console.log('Bravo Auth token ', data);
      } catch (e) {
        console.log('TeamRecognitionService.Bravo error', e);
        return { error: 'There was a problem with the JSON data.' };
      }
    } else {
      console.error('TeamRecognitionService.Bravo  error calling API', response.statusText);
      return {
        error: 'There was a problem retrieving the Bravo data.',
      };
    }
  } catch (E) {
    console.log('TeamRecognitionService.Bravo error', E);
    return {
      error: 'There was a problem retrieving the Bravo data.',
    };
  }

  if (data && data.userMessage) {
    //There is an error message in the data that was returned
    console.error('TeamRecognitionService.Bravo  error', data.userMessage);
    return { error: data.userMessage };
  }
 // console.log('Bravo response', data);
  if (!data.access_token) {
    console.error('TeamRecognitionService.Bravo  error no data.access_token');
    return { error: data.userMessage };
  }

  const bravoAccessToken = data.access_token;
  sessionStorage.setItem('bravoAccessToken', bravoAccessToken);

  // console.log('Bravo bearer token', token);
  let BravoHeaders = new Headers();
  BravoHeaders.append('Content-Type', 'application/json');
  BravoHeaders.append('Authorization', 'Bearer ' + token);
  BravoHeaders.append('X-NW-Message-ID', message);
  BravoHeaders.set('client_id', portalKey);

  let bravoData = null,
    totalCount = 0,
    pageNum = 0,
    bravos = [],
    managerBravos = [],
    nextPage = true;
  while (nextPage) {
    const body2 = {
      shortName: encodeURIComponent(shortName),
      token: encodeURIComponent(bravoAccessToken),
      page: encodeURIComponent(pageNum),
    };
    pageNum++;
    try {
      const response = await fetch(portalApi, {
        method: 'post',
        headers: BravoHeaders,
        body: JSON.stringify(body2),
      });
      if (response.ok) {
        try {
          bravoData = await response.json();
        } catch (e) {
          //Response status was OK, but we got an error getting the json data
          console.error('TeamRecognitionService.Bravo error', e);
          return { error: 'There was a problem with the JSON data.' };
        }
      } else {
        return {
          error: 'There was a problem retrieving the Bravo data.',
        };
      }
    } catch (E) {
      //There was an error calling the API
      console.error('TeamRecognitionService.Bravo  error', E);
      return {
        error: 'There was a problem retrieving the Bravo data.',
      };
    }

    if (bravoData && bravoData.userMessage) {
      //There is an error message in the data that was returned
      return { error: bravoData.userMessage };
    }

    try {
      if (bravoData && bravoData.data.events.length > 0) {
        //data was retrieved and has approval entries
        for (let x = 0; x < bravoData.data.events.length; x++) {
          //loop through the Bravo!

          if (bravoData.data.events[x].programName == 'Bravo!') {
            let shortname = bravoData.data.events[x].recipients[0].email;

            //shortname = shortname.substring(0, shortname.indexOf('@')).toUpperCase();
            let date = bravoData.data.events[x].eventDate;
            let eid = bravoData.data.events[x].eventId;
            let from = bravoData.data.events[x].nominator.email;
            let name = bravoData.data.events[x].recipients[0].fullName;
            from = from.substring(0, from.indexOf('@')).toUpperCase();

            bravos[x + totalCount] = {
              shortName: shortname,
              type: 'Bravo',
              Date: date,
              eventId: eid,
              From: from,
              name: name,
            };
          }
        }
        totalCount += bravoData.data.events.length;
      }
      nextPage = bravoData.data.events.length >= 100 ? true : false;
      pageNum++;
    } catch (err) {
      return { error: 'There was an error parsing BravoData' };
    }
  }
  // Start Bravos sent call
  let BravoSentHeaders = new Headers();
  BravoSentHeaders.append('Content-Type', 'application/json');
  BravoSentHeaders.append('Authorization', 'Bearer ' + token);
  BravoSentHeaders.append('X-NW-Message-ID', message);
  BravoSentHeaders.set('client_id', portalKey);

  let bravoSentData = null;

  // Calculate start date
  let today = new Date(Date.now());
  let two_weeksAgo = today - 12096e5;
  let startDate = formatDate(two_weeksAgo);

  const body3 = {
    shortName: encodeURIComponent(shortName),
    token: encodeURIComponent(bravoAccessToken),
    page: encodeURIComponent('0'),
    startDate: encodeURIComponent(startDate),
  };

  try {
    const response = await fetch(sentBravoAPI, {
      method: 'post',
      headers: BravoSentHeaders,
      body: JSON.stringify(body3),
    });
    if (response.ok) {
      try {
        bravoSentData = await response.json();
      } catch (e) {
        //Response status was OK, but we got an error getting the json data
        console.error('TeamRecognitionService.Bravo error', e);
        return { error: 'There was a problem with the JSON data.' };
      }
    } else {
      return {
        error: 'There was a problem retrieving the Bravo data.',
      };
    }
  } catch (E) {
    //There was an error calling the API
    console.error('TeamRecognitionService.Bravo  error', E);
    return {
      error: 'There was a problem retrieving the Bravo data.',
    };
  }

  if (bravoSentData && bravoSentData.userMessage) {
    //There is an error message in the data that was returned
    return { error: bravoSentData.userMessage };
  }

  if (bravoSentData && bravoSentData.data.count > 0) {
    //data was retrieved and has approval entries

    managerBravos = [];
    //console.log('Return Bravo service ', bravoSentData);
    // bravoSentData = bravoTester;
    let manNum = 0;
    for (let x = 0; x < bravoSentData.data.count; x++) {
      //loop through the Bravo!
      try {
        if (bravoSentData.data.recognitions[0].recognitionType == 'ecard') {
          if (bravoSentData.data.recognitions[0].ecard.length > 0) {
            let shortname = bravoSentData.data.recognitions[0].ecard[x].recipient.emailId;
            shortname = shortname.substring(0, shortname.indexOf('@')).toUpperCase();
            let name = bravoSentData.data.recognitions[0].ecard[x].recipient.name;
            let date = bravoSentData.data.recognitions[0].ecard[x].date;
            // console.log('Return Bravo service ', shortname, date, name);
            managerBravos[manNum++] = {
              shortName: shortname,
              type: 'Bravo',
              Date: date,
              name: name,
            };
          }
        }
      } catch (err) {
        console.log('Error on Bravo data ', err);
        return { error: 'There was a problem parsing Bravo data.' };
      }
    }
  }
  managerBravos.sort((a, b) => new Date(b.Date) - new Date(a.Date));
  console.log('Return Bravo service ', managerBravos, bravos);
  const error = null;
  return {
    entries: bravos,
    managerBravos: managerBravos,
    snowError: error,
    error,
  };
};

export const getAchieverData = async () => {
  const environ = getEnvironment();
  let portalAuthApi = config.achieversAuthAPI;
  let portalKey = config.bravoKey;
  let portalApi = config.achieversDataAPI;
  let callupAPI = config.callupReportsAPI;
  let callupKey = config.callupKey;

  if (environ !== 'DEFAULT') {
    callupAPI = config.test_callupReportsAPI;
    callupKey = config.test_callupKey;
    portalAuthApi = config.test_achieversAuthAPI;
    portalKey = config.test_bravoKey;
    portalApi = config.test_achieversDataAPI;
  }
  const userInfo = JSON.parse(sessionStorage.getItem('userinfo'));
  if (!userInfo || !userInfo.shortName) {
    return { error: 'No user information found.' };
  }
  let shortName = userInfo.shortName
    ? userInfo.shortName.toUpperCase()
    : userInfo.username.toUpperCase();

  const callupInfo = JSON.parse(sessionStorage.getItem('contact'));

  const testUsers = testers.users;
  for (let x = 0; x < testUsers.length; x++) {
    const tester = testUsers[x];
    if (tester.shortName.toUpperCase() === shortName.toUpperCase()) {
      //User shortname matches to a tester
      if (environ === 'DEFAULT') {
        //This is the production environment
        if (tester.prodAllowed) {
          //This tester is allowed to mimic in production
          shortName = tester.mimicManager.toUpperCase();
        }
      } else {
        //This is not a production environment
        shortName = tester.mimicManager.toUpperCase();
      }
      break;
    }
  }
  // sessionStorage.removeItem('access_token');
  const message = getRandomString(25);
  const token = sessionStorage.getItem('access_token');

  const callupBody = {
    shortName: encodeURIComponent(shortName),
  };

  let callupHeaders = new Headers();
  callupHeaders.append('Content-Type', 'application/json');
  callupHeaders.append('X-NW-Message-ID', message);
  callupHeaders.append('Authorization', 'Bearer ' + token);
  callupHeaders.set('client_id', callupKey);

  const response = await fetch(callupAPI, {
    method: 'POST',
    headers: callupHeaders,
    body: JSON.stringify(callupBody),
  });

  let teamData = {};

  if (response.ok) {
    try {
      teamData = await response.json();
      teamData = teamData.contacts;
      teamData = teamData.filter((contact) => contact.employeeType === 'Regular');
    } catch (e) {
      console.error('teamService.getManagerTeam Callup API error', e);
    }
  }

  let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Authorization', 'Bearer ' + token);
  headers.append('X-NW-Message-ID', message);
  headers.set('client_id', portalKey);

  const body = {shortName: encodeURIComponent(shortName)};
  let data = null;
  try {
    const response = await fetch(portalAuthApi, {
      method: 'post',
      headers: headers,
      body: JSON.stringify(body),
    });
    if (response.ok) {
      try {
        data = await response.json();
      } catch (e) {
        console.log('TeamRecognitionService.Achievers error', e);
        return { error: 'There was a problem with the JSON data.' };
      }
    } else {
      console.error('TeamRecognitionService.Achievers  error calling API', response.statusText);
      return {
        error: 'There was a problem retrieving the Achievers data.',
      };
    }
  } catch (E) {
    console.log('TeamRecognitionService.Achievers error', E);
    return {
      error: 'There was a problem retrieving the Achievers data.',
    };
  }

  if (data && data.userMessage) {
    //There is an error message in the data that was returned
    console.error('TeamRecognitionService.Achievers  error', data.userMessage);
    return { error: data.userMessage };
  }
  if (!data.access_token) {
    console.error('TeamRecognitionService.Achievers  error no data.access_token');
    return { error: data.userMessage };
  }

  const achieversAccessToken = data.access_token;
  sessionStorage.setItem('achieversAccessToken', achieversAccessToken);

  let AchieversHeaders = new Headers();
  AchieversHeaders.append('Content-Type', 'application/json');
  AchieversHeaders.append('Authorization', 'Bearer ' + token);
  AchieversHeaders.append('X-NW-Message-ID', message);
  AchieversHeaders.set('client_id', portalKey);

  let achieversData = null,
    totalCount = 0,
    bravos = [],
    achieversManagerBravos = [];
  const daysAgo = 90;
  const beginDate = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000);
  const startDate = beginDate.toISOString().slice(0, 19) + '-05:00';
  const today = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000);
  const endDate = today.toISOString().slice(0, 19) + '-05:00';
  console.log('team Data', teamData.length, 'team data first item ', teamData[0]);
  for (let x = 0; x < teamData.length; x++) {
    const body2 = {
      shortName: encodeURIComponent(shortName),
      associate: encodeURIComponent(teamData[x].shortName),
      token: achieversAccessToken,
      startDate: encodeURIComponent(startDate),
      endDate: encodeURIComponent(endDate)
    };
    try {
      const response = await fetch(portalApi, {
        method: 'post',
        headers: AchieversHeaders,
        body: JSON.stringify(body2),
      });
      if (response.ok) {
        try {
          achieversData = await response.json();
          achieversData = achieversData.items;
        } catch (e) {
          //Response status was OK, but we got an error getting the json data
          console.error('TeamRecognitionService.Achievers error', e);
          return { error: 'There was a problem with the JSON data.' };
        }
      } else {
        console.error('TeamRecognitionService.Achievers  error');
      }
      
      if (achieversData && achieversData.userMessage) {
        //There is an error message in the data that was returned
        return { error: achieversData.userMessage };
      }
       for (let y = 0; y < achieversData.length; y++) {
          for (let z = 0; z < achieversData[y].nominees.length; z++) {
            if (achieversData[y].nominees[z].name == teamData[x].firstName + ' ' + teamData[x].lastName) {
              bravos[totalCount++] = {
              shortName: teamData[x].shortName,
              type: 'Bravo',
              Date: achieversData[y].dateCreated,
              eventId: achieversData[y].newsfeedEventURL,
              From: achieversData[y].nominator.name,
              name: achieversData[y].nominees[z].name,
              };
            }
          }
       }
    } catch (E) {
      //There was an error calling the API
      console.error('TeamRecognitionService.Achievers  error', E);
    }
  }
  console.log('Bravos received ', bravos);

  const daysAgoManager = 14; //14
  const beginDateManager = new Date(Date.now() - daysAgoManager * 24 * 60 * 60 * 1000);
  const startDateManager = beginDateManager.toISOString().slice(0, 19) + '-05:00';
  let manNum = 0;

  const body3 = {
      shortName: encodeURIComponent(shortName),
      associate: encodeURIComponent(shortName),
      token: achieversAccessToken,
      startDate: encodeURIComponent(startDateManager),
      endDate: encodeURIComponent(endDate)
    };

  try {
      const response = await fetch(portalApi, {
        method: 'post',
        headers: AchieversHeaders,
        body: JSON.stringify(body3),
      });
      if (response.ok) {
        try {
          achieversData = await response.json();
          achieversData = achieversData.items;
        } catch (e) {
          //Response status was OK, but we got an error getting the json data
          console.error('TeamRecognitionService.Achievers Manager error', e);
          return { error: 'There was a problem with the JSON data.' };
        }
      } else {
        console.error('TeamRecognitionService.Achievers Manager  error');
      }

      if (achieversData && achieversData.userMessage) {
        //There is an error message in the data that was returned
        return { error: achieversData.userMessage };
      }
       for (let y = 0; y < achieversData.length; y++) {
          if (achieversData[y].nominator.name == callupInfo.firstName + ' ' + callupInfo.lastName) {
            for (let z = 0; z < achieversData[y].nominees.length; z++) {
              achieversManagerBravos[manNum++] = {
                type: 'Bravo',
                Date: achieversData[y].dateCreated,
                name: achieversData[y].nominees[z].name
              };
          }
          }
       }
       console.log('Finished processing achievers manager bravos, ', achieversManagerBravos);
    } catch (E) {
      //There was an error calling the API
      console.error('TeamRecognitionService.Achievers  Manager Bravos Error', E);
    }
  achieversManagerBravos.sort((a, b) => new Date(b.Date) - new Date(a.Date));
  console.log('Manager Bravos ', achieversManagerBravos);
  const error = null;
  return {
    entries: bravos,
    achieversManagerBravos: achieversManagerBravos,
    snowError: error,
    error,
  };
};

function encodeKeyValuePair(key, value) {
  return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [month, day, year].join('');
}
